/**
 * Local image paths (files in public/images, downloaded via scripts/download-assets.js).
 * Uses root path so images load in both dev and production.
 */
function imagePath(name: string): string {
  const base =
    typeof process !== "undefined" && process.env?.PUBLIC_URL
      ? String(process.env.PUBLIC_URL).replace(/\/$/, "")
      : "";
  const prefix = base ? `${base}/` : "/";
  return `${prefix}images/${name}`;
}

export const ASSETS = {
  logo: imagePath("logo.png"),
  logoWhite: imagePath("logo-white.png"),
  ellipse: imagePath("ellipse.svg"),
  ellipse2: imagePath("ellipse2.svg"),
  iconExpert: imagePath("icon-expert.png"),
  iconScales: imagePath("icon-scales.png"),
  iconTarget: imagePath("icon-target.png"),
  iconHandshake: imagePath("icon-handshake.png"),
  iconCommunication: imagePath("icon-communication.png"),
  iconDeadline: imagePath("icon-deadline.png"),
  teamAvatar1: imagePath("team-vasil.jpeg"),
  teamAvatar2: imagePath("team-2.png"),
  teamAvatar3: imagePath("team-3.png"),
  teamAvatar4: imagePath("team-4.png"),
  teamAvatarYanaMarcheva: imagePath("team-yana-marcheva.png"),
  teamAvatarVasilenaToteva: imagePath("team-vasilena-toteva.png"),
  teamAvatarZornitsa: imagePath("team-zornitsa.jpeg"),
  teamAvatarPlaceholder: imagePath("team-3.png"),
  iconEmail: imagePath("icon-email.png"),
  iconPhone: imagePath("icon-phone.png"),
  iconLocation: imagePath("icon-location.png"),
  partners: [
    imagePath("partner-1.png"),
    imagePath("partner-2.png"),
    imagePath("partner-3.png"),
    imagePath("partner-4.png"),
    imagePath("partner-5.png"),
    imagePath("partner-6.png"),
    imagePath("partner-7.png"),
    imagePath("partner-8.png"),
    imagePath("partner-9.png"),
  ],
} as const;

/** Keys of ASSETS that are single image paths (string), not arrays */
export type AssetImageKey = Exclude<keyof typeof ASSETS, "partners">;
